import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Box,
    Drawer,
    IconButton,
    Stack,
    Typography,
} from '@mui/material';
import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import CloseIcon from '@mui/icons-material/Close';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Routes } from 'src/utils/enums';
import { navbarMenu } from 'src/resources/data/landingPageData';

interface SideBarProps {
    isDrawerOpen: boolean;
    setIsDrawerOpen: (isOpen: boolean) => void;
}

const SideBar: React.FC<SideBarProps> = ({ isDrawerOpen, setIsDrawerOpen }) => {
    const [expandedIndex, setExpandedIndex] = useState<number | false>(false);

    const navigate = useNavigate();
    const location = useLocation();

    const handleExpandClick = (index: number) => {
        setExpandedIndex((prev) => (prev === index ? false : index));
    };

    const handleNavigateToSelectedService = (link: string): void => {
        if (link) {
            setIsDrawerOpen(false);
            navigate('/');
            navigate(link);
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
    }

    return (
        <Drawer anchor="right" open={isDrawerOpen} sx={{ zIndex: 4000 }}>
            <Stack p={4} alignItems="start" direction="column" gap={4} width="20rem">
                <Box display="flex" justifyContent="end" flexDirection="row" width="100%">
                    <IconButton onClick={() => setIsDrawerOpen(false)}>
                        <CloseIcon />
                    </IconButton>
                </Box>

                {navbarMenu.map((menuItem, index) =>
                    menuItem.subMenu?.length ? (
                        <Accordion
                            key={index}
                            expanded={expandedIndex === index}
                            disableGutters
                            elevation={0}
                            square
                            sx={{
                                background: 'transparent',
                                '&::before': { display: 'none' },
                            }}
                        >
                            <AccordionSummary
                                aria-controls={`panel${index}-content`}
                                id={`panel${index}-header`}
                                sx={{
                                    padding: 0,
                                    minHeight: 'unset',
                                    cursor: 'default',
                                    '& .MuiAccordionSummary-content': {
                                        margin: 0,
                                    },
                                }}
                                onClick={(e) => e.stopPropagation()}
                            >
                                <Stack gap={4} alignItems="center" direction="row">
                                    <Typography
                                        variant="h4_Thin"
                                        color={location.pathname.includes(menuItem.link) ? "primary.main" : "primary.dark"}
                                        onClick={() => navigate(Routes.SERVICES_PAGE)}
                                        sx={{
                                            cursor: 'pointer',
                                            ":hover": {
                                                color: "#ea728c"
                                            }
                                        }}
                                    >
                                        {menuItem.title}
                                    </Typography>

                                    <IconButton
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            handleExpandClick(index);
                                        }}
                                        sx={{ marginLeft: 'auto' }}
                                    >
                                        <ExpandMoreIcon
                                            sx={{
                                                transform: expandedIndex === index ? 'rotate(180deg)' : 'rotate(0deg)',
                                                transition: 'transform 0.2s',
                                            }}
                                        />
                                    </IconButton>
                                </Stack>
                            </AccordionSummary>

                            <AccordionDetails sx={{ paddingLeft: 2, paddingTop: 0.5 }}>
                                <Stack mt={2} alignItems="start" direction="column" gap={2}>
                                    {menuItem.subMenu.map((sub, i) => (
                                        <Typography
                                            key={i}
                                            variant="h6_Thin"
                                            sx={{
                                                cursor: 'pointer',
                                                ":hover": {
                                                    color: '#ea728c',
                                                },
                                            }}
                                            //TODO: Fix this navigation logic
                                            onClick={() => handleNavigateToSelectedService(sub?.link || "")}
                                        >
                                            {sub.title}
                                        </Typography>
                                    ))}
                                </Stack>
                            </AccordionDetails>
                        </Accordion>
                    ) : (
                        <Typography
                            key={index}
                            variant="h4_Thin"
                            color={location.pathname === menuItem.link ? "primary.main" : "primary.dark"}
                            sx={{
                                cursor: 'pointer',
                                ":hover": {
                                    color: '#ea728c',
                                },
                            }}
                            onClick={() => {
                                setIsDrawerOpen(false);
                                navigate(menuItem.link);
                            }}
                        >
                            {menuItem.title}
                        </Typography>
                    )
                )}
            </Stack>
        </Drawer>
    );
};

export default SideBar;